<template>
  <div class="order_detail">
    <div class="order_detail_nav">
      <navbar
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        @goback="goBack(false)"
      />
    </div>
    <div class="box" :style="boxSty" v-if="detailInfo">
      <van-row class="status _status">
        <van-col span="24" class="tit">
          <img src="@/assets/purchaseSupplier/order/car.png" />{{detailInfo.status == 30 ?'等待供应方收货':'供应方已收货'}}
        </van-col>
        <van-col span="24" class="tips" v-if="detailInfo.confirm_time">
          <!-- {{ statusTip }} -->
          确认收货时间：{{detailInfo.confirm_time}}
        </van-col>
      </van-row>
      <div class="content">
        <van-row class="after_reason">
          <van-col span="24" class="title">售后信息</van-col>
          <van-col span="24" class="item"> 售后类型：{{detailInfo.type | filter}} </van-col>
          <van-col
            span="24"
            class="item item-line"
            v-if="detailInfo.application_information"
            >售后原因：{{ detailInfo.application_information.reason }}</van-col
          >
        </van-row>
        <van-row class="order_info">
          <van-col span="24" class="title">
            寄回物流信息
            <div class="more_icon" @click="checkLogistics">
              查看物流 <img src="@/assets/purchaseSupplier/order/more_icon.png" alt="">
            </div>
          </van-col>
           <van-col span="24" class="item" v-if="detailInfo.application_information">
            物流公司：{{ detailInfo.application_information.return_post_name}}
          </van-col>
          <van-col span="24" class="item" v-if="detailInfo.application_information">
            物流单号：<span ref="copytxt3">{{ detailInfo.application_information.return_post_no }}</span>
            <img
              class="copy"
              src="../../../assets/purchaseSupplier/common/copy.png"
              @click="copyCode(3)"
            />
          </van-col>

          <van-col span="24" class="item">
            发货时间：{{ detailInfo.delivery_time}}
          </van-col>
          <van-col span="24" class="item item-return-image" v-if="detailInfo.application_information">
            物流凭证：<div>
              <div class="item-return-box" v-for="(l,s) in detailInfo.application_information.return_express_images" @click="imgPreview(s)" :key="s">
                <img :src="l" alt="">
                <img src="@/assets/purchaseSupplier/order/oversize_icon.png" class="oversize-icon" alt="">
              </div>
            </div>
          </van-col>
        </van-row>
          <van-row v-if="detailInfo.delivery_address">
          <van-col span="24" class="show_address">
            <p class="name">
              <img
                class="address"
                src="../../../assets/purchaseSupplier/common/address.png"
              />
              {{ detailInfo.delivery_address.consignee }}
              <span>{{ detailInfo.delivery_address.consignee_mobile }}</span>
              <img
                class="copy"
                src="../../../assets/purchaseSupplier/common/copy.png"
                @click="copyCode(1)"
              />
            </p>
            <p class="site" ref="copytxt1">
              {{
                detailInfo.delivery_address.address_name +
                detailInfo.delivery_address.address
              }}
            </p>
          </van-col>
        </van-row>
        <van-row class="goods_info_box">
          <van-col span="24" class="title">商品信息</van-col>

          <van-col span="24" class="goods_info">
            <div class="info_box">
              <div class="left">
                <img :src="detailInfo.sku_image" @error="nofind()" />
                <!-- <p class="goods_name">{{ detailInfo.goods_name }}</p> -->
                <div class="wrapper-goods-name">
                  <input id="exp2"  class="exp"  type="checkbox">
                  <div class="text">
                    <label class="btn" for="exp2"></label>
                    {{ detailInfo.goods_name }}
                  </div>
                </div>
                <!-- <p class="spec">{{ detailInfo.specification_name }}</p> -->
                <p class="spec">
                  <span v-if="detailInfo.specification_name">规格：</span
                  >{{ detailInfo.specification_name }}
                </p>
                <!-- <p>运费￥{{ detailInfo.goods_postage }}</p> -->
              </div>
              <div class="right">
                <p>￥{{ detailInfo.cost_price }}</p>
                <p>X{{ detailInfo.quantity }}</p>
              </div>
              <p class="goods_postage">运费￥{{ detailInfo.goods_postage }}</p>
            </div>
            <p class="money">
              合计金额：<span>￥{{ detailInfo.amount }}</span>
            </p>
          </van-col>
        </van-row>
        <van-row class="order_info">
          <van-col span="24" class="item">
            订单编号：
            <span ref="copytxt2">{{ detailInfo.ordersn }}</span>
            <img
              class="copy"
              src="../../../assets/purchaseSupplier/common/copy.png"
              @click="copyCode(2)"
            />
          </van-col>
          <van-col span="24" class="item">
            付款时间：{{ detailInfo.pay_time }}
          </van-col>
          <van-col
            span="24"
            class="item item_wrap"
            v-if="detailInfo.buyer_remark"
          >
            买家备注：{{ detailInfo.buyer_remark }}
          </van-col>
        </van-row>
         <van-row class="supplier_info"
          v-if="detailInfo.supplier_remark">
          <van-col  span="24" class="item-noremark">
            <div>集采供应方备注：{{ detailInfo.supplier_remark }}</div>
          </van-col>
        </van-row>
      </div>
    </div>
    <van-row class="order_detail_footer">
      <van-col span="24" class="show_button" :style="detailInfo.status != 30?'flex-direction: row-reverse;':''">
        <btn
          :btntext="'联系买家'"
          :btnwidth="'16.5rem'"
          :height="'4.4rem'"
          :bgcolor="'#fff'"
          :borderradius="'2.2rem'"
          :btncolor="'#333'"
          :fontsize="'1.6rem'"
          :btnborder="'solid 0.05rem #eee'"
          @btnClick="contact"
        />
        <btn
          :btntext="'确认收货'"
          :btnwidth="'16.5rem'"
          :height="'4.4rem'"
          :bgcolor="'linear-gradient(to right, #fc740c, #f41a3c)'"
          :borderradius="'2.2rem'"
          :btncolor="'#fff'"
          :fontsize="'1.6rem'"
          :btnmargin="'0 0 0 1.2rem'"
          v-if="detailInfo.status==30"
          @btnClick="receive"
        />
      </van-col>
    </van-row>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
import defaultImg from "@/assets/common/compare.png";
import {ImagePreview} from "vant";

export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/my/reback.png"),
      detailInfo: {},
      boxSty: { padding: "8.8rem 1.6rem 6.5rem" },
      statusTip: "",
      timer: "",
      // storeId: "",
      isSupplier: ""
    };
  },
  created() {
    // this.storeId = this.$route.query.store_id;
    this.isSupplier = this.$route.query.is_supplier;
    this.getInfo();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getInfo() {
      this.$api
        .post("/onorder/member/supplier/after/sale/order/detail", {
          id: this.$route.query.id,
          supplier_member_id: this.$route.query.supplier_member_id,
        })
        .then((res) => {
          // res.delivery_address = JSON.parse(res.delivery_address);
          this.detailInfo = res;
          let auto_cancel_time = res.auto_cancel_time.replace(/-/g, "/");
          let end_time = Math.floor(
            new Date(auto_cancel_time).getTime() / 1000
          );
          this.setTimer(end_time);
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    setTimer(end_time) {
      var _that = this;
      var current = Math.floor(new Date().getTime() / 1000);
      var ts = end_time - current;
      if (ts <= 0) {
        this.statusTip = "剩余00天00小时00分钟自动确认收货";
        clearInterval(this.timer);
        return false;
      } else {
        _that.getTimeCount(ts, _that);
      }
      this.timer = setInterval(function () {
        var current = Math.floor(new Date().getTime() / 1000);
        var ts = end_time - current;
        if (ts <= 0) {
          this.statusTip = "剩余00天00小时00分钟自动确认收货";
          clearInterval(this.timer);
          return false;
        } else {
          _that.getTimeCount(ts, _that);
        }
      }, 60000);
    },
    //支付时间倒计时
    getTimeCount(ts, _that) {
      var dd = parseInt(ts / 60 / 60 / 24, 10); //计算剩余的天数
      var hh = parseInt((ts / 60 / 60) % 24, 10); //计算剩余的小时数
      var mm = parseInt((ts / 60) % 60, 10); //计算剩余的分钟数
      // var ss = parseInt(ts  % 60, 10);//计算剩余的秒数
      this.statusTip =
        "剩余" +
        _that.checkTime(dd) +
        "天" +
        _that.checkTime(hh) +
        "小时" +
        _that.checkTime(mm) +
        "分钟自动确认收货";
    },
    contact() {
      let parm = {
        id: this.detailInfo.member_id,
        name: this.detailInfo.user_name,
        store_id: this.detailInfo.shop_id,
        supplier_member_id: this.detailInfo.supplier_member_id,
      };
      this.params(JSON.stringify(parm), JSON.stringify(parm), "contact");
    },
    receive() {
      this.$api
        .post("onorder/member/after/sale/supplier/confirm/receipt", {
          id: this.$route.query.id,
        })
        .then((res) => {
          this.$router.push({
            path: "/purchaseSupplier/result",
            query: {
              type: 1,
            },
          });
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    copyCode(index) {
      const rechage_range = document.createRange();
      if (index == 1) {
        rechage_range.selectNode(this.$refs.copytxt1);
      } else if(index == 2){
        rechage_range.selectNode(this.$refs.copytxt2);
      }else{
        rechage_range.selectNode(this.$refs.copytxt3);
      }
      const rechage_selection = window.getSelection();
      if (rechage_selection.rangeCount > 0) rechage_selection.removeAllRanges();
      rechage_selection.addRange(rechage_range);
      document.execCommand("Copy");
      this.$toast("复制成功");
      rechage_selection.removeAllRanges();
    },
    nofind() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
    imgPreview(index) {
      ImagePreview({
        images: this.detailInfo.application_information.return_express_images,
        startPosition: index,
      });
    },
    checkLogistics(){
       localStorage.setItem(
        "delivery_address",
        JSON.stringify(this.detailInfo.return_address)
      );
      this.$router.push({
        path: "/purchaseSupplier/logisticsDetail",
        query: {
          com: this.detailInfo.application_information.return_post_code,
          nu: this.detailInfo.application_information.return_post_no,
          name: this.detailInfo.application_information.return_post_name,
          phone: this.detailInfo.return_address.consignee_mobile,
        },
      });
    }
  },
   mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );

    window.onresize = () => {
      document.documentElement.style.setProperty(
        "font-size",
        (document.body.clientWidth / 375) * 10 + "px"
      );
    };
  },
  filters:{
    filter(val){
      switch(val){
        case 1:
          return '退货退款';
        case 2:
          return '仅退款';
        case 3:
          return '换货';
      }
    }
  }
};
</script>
<style lang="less" scoped>
.order_detail {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .order_detail_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    // background-color: #f5f6f7;
    z-index: 3;
  }

  .box {
    // padding: 10.4rem 1.6rem 6.5rem;
    box-sizing: border-box;
    height: 100%;
    background: url(../../../assets/purchaseSupplier/order/bg@2x.png) no-repeat
      center top;
    background-size: 100% 18rem;

    .status {
      color: #fff;
      font-size: 2rem;
      height: 2.8rem;
      text-align: center;
      margin-bottom: 1.3rem;
      font-weight: 700;

      .tit {
        line-height: 2.8rem;

        img {
          width: 2.4rem;
          margin-right: 0.8rem;
          vertical-align: middle;
        }
      }
    }

    ._status {
      height: 4.5rem;
      margin-bottom: 1.2rem;

      .tips {
        line-height: 1.7rem;
        font-size: 1.2rem;
        font-weight: 400;
      }
    }

    .content {
      height: calc(100% - 5.7rem);
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      .after_reason {
        color: #333;
        font-size: 1.4rem;
        min-height: 8rem;
        padding: 1.6rem 1.2rem;
        background: #fff;
        border-radius: 0.8rem;
        margin-bottom: 1.2rem;
        text-align: left;
        box-sizing: border-box;
        .item {
          color: #333;
          line-height: 3.2rem;
        }
        .item-line{
          line-height: 2rem;
        }
        .title {
          font-weight: 700;
          line-height: 2rem;
          // margin-block: 0.8rem;
        }

        .tips {
          line-height: 2rem;
        }
      }

      .show_address {
        min-height: 8.3rem;
        padding: 2.2rem 2.2rem 2rem 1.6rem;
        background: #fff;
        border-radius: 0.8rem;
        margin-bottom: 1.2rem;
        text-align: left;
        position: relative;
        box-sizing: border-box;

        .name {
          color: #333;
          font-size: 1.4rem;
          font-weight: 700;
          height: 2rem;
          line-height: 2rem;
          margin-bottom: 0.4rem;

          img {
            width: 2rem;
            vertical-align: middle;
          }

          .address {
            margin-right: 1.2rem;
          }

          .copy {
            float: right;
          }

          span {
            margin-left: 1.2rem;
          }
        }

        .site {
          color: #999;
          font-size: 1.2rem;
          line-height: 1.7rem;
          padding-left: 3.2rem;
        }
      }

      .goods_info_box {
        min-height: 17.4rem;
        border-radius: 0.8rem;
        background: #fff;
        padding: 1.6rem 1.2rem 2rem;
        color: #333;
        font-size: 1.4rem;
        box-sizing: border-box;
        margin-bottom: 1.2rem;

        .title {
          color: #333;
          font-size: 1.4rem;
          line-height: 2rem;
          font-weight: 700;
        }

        .goods_info {
          min-height: 11.8rem;
          font-size: 1.4rem;
          color: #333;
          padding-top: 1.6rem;
          box-sizing: border-box;

          .info_box {
            position: relative;

            .left {
              min-height: 70px;
              padding: 0 6.5rem 0 8rem;

              img {
                width: 7rem;
                height: 7rem;
                position: absolute;
                top: 0;
                left: 0;
              }

              p {
                line-height: 2rem;
              }

              .goods_name {
                height: auto;
                // height: 2rem;
                // white-space: nowrap;
                // overflow: hidden;
                // text-overflow: ellipsis;
              }
              .wrapper-goods-name{
                display: inline-flex;
                overflow: hidden;
              /*   resize: horizontal; */
                .text {
                  font-size: 1.4rem;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  text-align: justify;
                  /* display: flex; */
                /*   display: -webkit-box;
                  -webkit-line-clamp: 3;
                  -webkit-box-orient: vertical; */
                  position: relative;
                  line-height: 1.5;
                  max-height: 3em;
                }
                .text::before {
                  content: '';
                  height: calc(100% - 2rem);
                  float: right;
                }
                .text::after {
                  content: '';
                  width: 999vw;
                  height: 999vw;
                  position: absolute;
                  box-shadow: inset calc(10rem - 999vw) calc(2.5rem - 999vw) 0 0 #fff;
                  margin-left: -10rem;
                }
                .btn{
                  position: relative;
                  float: right;
                  clear: both;
                  font-size: 1.2rem;
                  line-height: 2rem;
                  color:  #427CFA;
                  cursor: pointer;
                }
                .btn::after{
                  content:'展开';
                  background: url('../../../assets/purchaseSupplier/order/show_icon.png') no-repeat center right /1.6rem 1rem;
                  padding-right: 1.6rem;
                  margin-left: 2rem;
                }
                .exp{
                  display: none;
                }
                .exp:checked+.text{
                  max-height: none;
                }
                .exp:checked+.text::after{
                  visibility: hidden;
                }
                .exp:checked+.text .btn::before{
                  visibility: hidden;
                  display: none;
                }
                .exp:checked+.text .btn::after{
                  content:'收起';
                  background: url('../../../assets/purchaseSupplier/order/up_icon.png') no-repeat center right /1.6rem 1rem;
                  margin-left: 0;
                }
                .btn::before{
                  content: '...';
                  position: absolute;
                  // left: -0.4rem;
                  left: 1.2rem;
                  color: #333;
                  transform: translateX(-100%)
                }
              }
              .spec {
                color: #999;
                margin: 0.4rem 0 0.6rem;
              }
            }

            .right {
              float: right;
              position: absolute;
              right: 0;
              top: 0;
              min-width: 6.5rem;
              text-align: right;

              p {
                margin-bottom: 0.4rem;
              }
            }

            .goods_postage {
              line-height: 2rem;
              text-align: right;
              font-size: 1.4rem;
              color: #999;
            }
          }

          .money {
            line-height: 2rem;
            text-align: right;
            margin-top: 0.4rem;

            span {
              color: #ff4747;
            }
          }
        }
      }

      .order_info {
        height: auto;
        border-radius: 0.8rem;
        background: #fff;
        padding: 1.4rem 1.2rem;
        color: #333;
        font-size: 1.4rem;
        box-sizing: border-box;
        margin-bottom: 1.2rem;
         .title {
          color: #333;
          font-size: 1.4rem;
          line-height: 2rem;
          font-weight: 700;
        }
        .more_icon{
          display: inline-block;
          float: right;
          color: #FC740C;
          font-size: 1.4rem;
          display: flex;
          align-items: center;
          &>img{
            width: 1rem;
            height: 1.6rem;
            margin-left: 0.4rem;
          }
        }
        .item {
          color: #333;
          line-height: 3.2rem;

          .copy {
            width: 2rem;
            vertical-align: middle;
            margin-left: 0.8rem;
          }
        }
        .item_wrap {
          line-height: 2rem;
        }
        .item-return-image{
          display: flex;
          &>div{
            margin-top: 0.8rem;
            flex: 1;
          }
        }
        .item-return-box{
          width: 5.2rem;
          height: 4rem;
          margin-right: 0.8rem;
          display: inline-block;
          position: relative;
          .oversize-icon{
            width: 1.4rem;
            height: 1.4rem;
            position: absolute;
            padding: 0 0 1rem 1rem;
            right: 0;
            top: 0;
          }
        }
        .item-return-image img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .order_detail_footer {
    height: 5.2rem;
    padding: 0.4rem 1.6rem 0;
    background: #fff;
    text-align: left;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    .show_button {
      display: flex;
      justify-content: space-between;
    }
  }
   .supplier_info {
        height: auto;
        border-radius: 0.8rem;
        background: #fff;
        padding: 1.4rem 0 1.4rem 1.2rem;
        color: #333;
        font-size: 1.4rem;
        box-sizing: border-box;
        margin-bottom: 1.2rem;
        .item-noremark {
          color: #333;
          display: flex;
          & > div {
            word-break: break-all;
            flex: 1;
            padding-right: 1rem;
            line-height: 2rem;
          }
        }
      }
}
</style>
<style lang="less" scoped>
.van-dialog {
  border-radius: 0;

  .van-dialog__confirm,
  .van-dialog__cancel {
    height: 5.2rem;
    font-size: 1.6rem;
  }

  .van-dialog__content--isolated {
    min-height: 6.2rem;

    .van-dialog__message {
      padding: 2.1rem 1rem;
      color: #333;
      font-weight: 700;
      font-size: 1.6rem;
    }
  }
}
</style>